import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guard/auth-guard-service';
import { loggedInAuthGuard } from './core/guard/logged-in-auth-guard';
import { LoginSuccessComponent } from './modules/settings/login/login-success/login-success.component';
import { NoAccessComponent } from './core/components/no-access/no-access.component';

const routes: Routes = [
  {
    path: 'login-success',
    component: LoginSuccessComponent,
  },

  {
    path: 'login',
    canActivate: [loggedInAuthGuard],
    loadChildren: () =>
      import('./modules/settings/login/login.module').then(
        (m) => m.LoginModule
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [loggedInAuthGuard],
    loadChildren: () =>
      import('./modules/settings/home/home.module').then((m) => m.HomeModule),
  },

  {
    path: 'manage-profile',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/manage-profile/manage-profile.module').then(
        (m) => m.ManageProfileModule
      ),
  },

  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },

  {
    path: 'planning-report',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./shared/component/planning-yearly-view/plan-report.module').then(
        (m) => m.PlanReportModule
      ),
  },

  {
    path: 'planning-sheet',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/planning-sheet/planning-sheet.module').then(
        (m) => m.PlanningSheetModule
      ),
  },
    {
    path: 'duties',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/duties/duties.module').then(
        (m) => m.DutiesModule
      ),
  },

  {
    path: 'duties/:id',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/duties/duties.module').then(
        (m) => m.DutiesModule
      ),
  },

  {
    path: 'staff',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/staff/staff.module').then(
        (m) => m.StaffModule
      ),
  },

  {
    path: 'staff/:id',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/staff/staff.module').then(
        (m) => m.StaffModule
      ),
  },

  {
    path: 'activities',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/activities/activities.module').then(
        (m) => m.ActivitiesModule
      ),
  },

  {
    path: 'activities/:id',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/activities/activities.module').then(
        (m) => m.ActivitiesModule
      ),
  },

  {
    path: 'staffs',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/staff/staff.module').then(
        (m) => m.StaffModule
      ),
  },

  {
    path: 'locations/:id',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/location/location.module').then(
        (m) => m.LocationModule
      ),
  },

  {
    path: 'locations',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/location/location.module').then(
        (m) => m.LocationModule
      ),
  },
  {
    path: 'organization',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/location/location.module').then(
        (m) => m.LocationModule
      ),
  },
  {
    path: 'holidays',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/holidays/holidays.module').then(
        (m) => m.HolidaysModule
      ),
  },

  {
    path: 'holidays/:id',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/holidays/holidays.module').then(
        (m) => m.HolidaysModule
      ),
  },

  {
    path: 'events',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/indicators/indicators.module').then(
        (m) => m.IndicatorsModule
      ),
  },

  {
    path: 'events/:id',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/indicators/indicators.module').then(
        (m) => m.IndicatorsModule
      ),
  },

  {
    path: 'opening-hours',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/opening-hours/opening-hours.module').then(
        (m) => m.OpeningHoursModule
      ),
  },

  {
    path: 'configuration',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/settings.module').then(
        (m) => m.SettingsModule
      ),
  },
  {
    path: 'notification-detail/:id',
    canActivate: [authGuard],
    loadChildren: () =>
      import(
        './modules/settings/user-notification/user-notification.module'
      ).then((m) => m.UserNotificationModule),
  },
  {
    path: 'notification-detail',
    canActivate: [authGuard],
    loadChildren: () =>
      import(
        './modules/settings/user-notification/user-notification.module'
      ).then((m) => m.UserNotificationModule),
  },

  {
    path: 'help-and-support',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/settings/help-support/help-support.module').then(
        (m) => m.HelpAndSupportModule
      ),
  },
  // { path: 'streams', pathMatch: 'full', redirectTo: 'streams/all' },
  // {
  //   path: 'streams',
  //   canActivate: [authGuard],
  //   loadChildren: () => import('./modules/settings/streams/streams.module').then(m => m.StreamsModule)
  // },
  { 
    path: 'employee-timesheet',
    canActivate: [authGuard],
     loadComponent: () =>
    import('./modules/settings/planning-sheet/timesheet/timesheet-view/timesheet-view.component').then(m => m.TimesheetViewComponent)
  },
  {
    path: '**',
    canActivate: [authGuard],// redirect to no access component only if the user is logged In, else redirect to home page
    component: NoAccessComponent, // This will be rendered inside <router-outlet>
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
